import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

// ანიმაციისთვის საჭირო @keyframes.
// ვამატებთ პირდაპირ კომპონენტში <style> თეგის სახით, რომ ყველაფერი ერთად იყოს.
const keyframes = `
  @keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
`;

const styles = {
  mainContainer: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 20px',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    background: 'linear-gradient(135deg, #0f2350 0%, #1b3f82 50%, #2563eb 100%)',
    borderTop: '1px solid rgba(71,146,244,0.30)',
  },
  title: {
    fontSize: 'clamp(1.8rem, 4vw, 3rem)',
    color: '#ffffff',
    fontWeight: '700',
    marginBottom: '0.5rem',
    textAlign: 'center',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '1rem',
    color: '#c0d8ff',
    marginBottom: '3rem',
    textAlign: 'center',
  },
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '24px',
    width: '100%',
    maxWidth: '1100px',
  },
  card: {
    background: 'rgba(255,255,255,0.88)',
    border: '1px solid rgba(71, 146, 244, 0.15)',
    borderTop: '4px solid #4792f4',
    borderRadius: '16px',
    padding: '36px 28px',
    width: '260px',
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
    boxShadow: '0 4px 24px rgba(71, 146, 244, 0.1)',
    transition: 'all 0.3s ease',
  },
  serviceName: {
    fontSize: '1rem',
    fontWeight: '600',
    color: '#3a5275',
    lineHeight: '1.5',
    marginBottom: '1rem',
  },
  price: {
    fontSize: '2.4rem',
    fontWeight: '800',
    color: '#0f1f40',
    margin: '0',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  priceSymbol: {
    fontSize: '1.6rem',
    color: '#4792f4',
    fontWeight: '700',
  },
  warning: {
    fontSize: '0.97rem',
    fontWeight: '500',
    color: 'rgba(255,255,255,0.92)',
    marginTop: '48px',
    maxWidth: '700px',
    textAlign: 'center',
    lineHeight: '1.7',
    padding: '1.1rem 1.75rem',
    background: 'linear-gradient(135deg, #4792f4 0%, #2563eb 100%)',
    borderRadius: '12px',
    boxShadow: '0 8px 24px rgba(71,146,244,0.25)',
  },
};

// --- მთავარი კომპონენტი ---
function CustomsPrice() {
  const { t } = useTranslation();

  const data = [
    { key: "1", name: t("table1"), price: "120" },
    { key: "2", name: t("table2"), price: "50" },
    { key: "3", name: t("table3"), price: "10" },
    { key: "4", name: t("table7"), price: t("negotiable") },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  return (
    <>
      <style>{keyframes}</style> {/* ანიმაციის დამატება */}
      <div style={styles.mainContainer} id='offers'>
        <motion.h1
          style={styles.title}
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          {t("offersTitle")}
        </motion.h1>
        <motion.p
          style={styles.subtitle}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
        </motion.p>

        <motion.div
          style={styles.cardsContainer}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {data.map((item) => (
            <motion.div
              key={item.key}
              style={styles.card}
              variants={cardVariants}
              whileHover={{
                scale: 1.05,
                boxShadow: '0 12px 32px rgba(71, 146, 244, 0.2)',
                borderColor: 'rgba(71, 146, 244, 0.45)'
              }}
              transition={{ type: 'spring', stiffness: 300 }}
            >
              <h3 style={styles.serviceName}>{item.name}</h3>
              <p style={{
                ...styles.price,
                fontSize: /^\d+$/.test(item.price) ? '2.4rem' : '1.3rem',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}>
                {item.price}
                {/^\d+$/.test(item.price) && <span style={styles.priceSymbol}>₾</span>}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.p
          style={styles.warning}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.5 }}
        >
          {t("warning")}
        </motion.p>
      </div>
    </>
  );
}

export default CustomsPrice;